import React, { useEffect, useState } from 'react';
import CustomQueryHeader from '../../views/CustomQueryHeader/CustomQueryHeader';
import 'bootstrap/dist/css/bootstrap.min.css';
import CustomQueryBody from '../../views/CustomQueryBody/CustomQueryBody';
import { pushAPIData } from '../../slices/customQuerySlice';
import { pushEntityKeyData } from '../../slices/entityCardSlice';
import { useSelector, useDispatch } from 'react-redux';
import customQueryStyles from './CustomQueryStyle';
import Spinner from '@material-ui/core/CircularProgress';
import SnackBar from '../../components/SnackBar/SnackBar';
import { showSnackEnable, showTostLoader, pushRunUrl, pushIsNavigating, pushDeleteSelectedItem } from '../../slices/customQueryHeaderSlice';
import { getPostResponseAPIData } from '../../services/apiService';
import consts from '../../utils/consts';
import ResultTable from '../../views/ResultTable/ResultTable';
import { pushSavedQueryData, pushSavedQueryName } from '../../slices/QueriesManagerSlice';

const CustomQuery = () => {
  const showCard = useSelector(state => state.customQueryBody.showCard);
  const showTable = useSelector(state => state.customQueryBody.showTable);
  const setLoaderComp = useSelector(state => state.customQueryBody.setLoaderComp);
  const filterCleared = useSelector(state => state.customQueryBody.filterCleared);
  const newFilterApplied = useSelector(state => state.customQueryBody.newFilterApplied);
  const relationTableData = useSelector(state => state.customQueryHeader.relationTableData);
  const isNavigating = useSelector(state => state.customQueryHeader.isNavigating);
  const queryName = useSelector(state => state.queriesManager.queryName);
  const queryData = useSelector(state => state.queriesManager.queryData);
  const apiResponse = useSelector(state => state.customQueryHeader.getCustomQuery);
  const postApiResponse = useSelector(state => state.customQueryHeader.postCustomQuery);
  const isSnackOpen = useSelector(state => state.customQueryHeader.snackEnable);
  const saveResponseData = useSelector(state => state.customQueryHeader.save);
  const showSnackLoader = useSelector(state => state.customQueryHeader.showSnackLoader);
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');
  const {
    baseUrl,
    entityNames,
    entitiesCardNames
  } = consts;
  const dispatch = useDispatch();
  let urlEntityNames = entityNames;
  useEffect(() => {
    let type = 'delete';
    let data = {};
    dispatch(pushDeleteSelectedItem({
      data,
      type
    }));
    dispatch(pushEntityKeyData(entitiesCardNames));

    if (saveResponseData && saveResponseData[0].data) {
      setMessage(saveResponseData[0].data.message);
      setStatus(saveResponseData[0].data.status);
      const adaQueryData = saveResponseData[0].data.adaQuery;

      if (queryName != '' && adaQueryData != null) {
        if (queryName && isNavigating) {
          dispatch(pushSavedQueryName(queryName));
          dispatch(pushSavedQueryData(queryData));
          dispatch(pushIsNavigating(false));
          processSave(adaQueryData);
        } else {
          dispatch(pushSavedQueryName(adaQueryData.queryname));
          dispatch(pushSavedQueryData(adaQueryData));
          processSave(adaQueryData);
        }
      }

      dispatch(showSnackEnable(true));
      dispatch(showTostLoader(true));
    }
  }, [saveResponseData]);
  useEffect(() => {
    dispatch(showSnackEnable(false));
    dispatch(showTostLoader(false));
  }, [dispatch]);
  useEffect(() => {
    dispatch(showSnackEnable(false));
    dispatch(showTostLoader(false));

    if (apiResponse && apiResponse.length > 0 && apiResponse[0].data) {
      let datafetch = [];
      let entityKeyData = [];
      apiResponse.forEach((response, index) => {
        if (apiResponse[index].data.applicationDetails && apiResponse[index].data.applicationDetails.length > 0) {
          datafetch.push({
            data: apiResponse[index].data.applicationDetails,
            type: 'applications'
          });
          let appKeys = Object.keys(apiResponse[index].data.applicationDetails[0]);
          appKeys = appKeys.filter(appKey => !appKey.includes('ID') && !appKey.includes('TYPE'));
          entityKeyData.push({
            entityKeys: appKeys,
            entityName: 'applications'
          });
        } else if (apiResponse[index].data.environmentDetails && apiResponse[index].data.environmentDetails.length > 0) {
          datafetch.push({
            data: apiResponse[index].data.environmentDetails,
            type: 'environments'
          });
          let envKeys = Object.keys(apiResponse[index].data.environmentDetails[0]);
          entityKeyData.push({
            entityKeys: envKeys,
            entityName: 'environments'
          });
        }
      });

      if (postApiResponse) {
        urlEntityNames.forEach((urlEntityName, index) => {
          datafetch.push({
            data: postApiResponse[index].data.queryData,
            type: urlEntityName === 'userAccounts' ? 'user accounts' : urlEntityName
          });
        });
        urlEntityNames.forEach((urlEntityName, index) => {
          if (postApiResponse[index].data.queryData && postApiResponse[index].data.queryData.length > 0) {
            let entityKeys = Object.keys(postApiResponse[index].data.queryData[0]);
            entityKeys = entityKeys.filter(entityKey => !entityKey.includes('ID') && !entityKey.includes('APPLICATION_TYPE'));
            entityKeyData.push({
              entityKeys: entityKeys,
              entityName: urlEntityName === 'userAccounts' ? 'user accounts' : urlEntityName
            });
          }
        });
      }

      dispatch(pushEntityKeyData(entityKeyData));
      dispatch(pushAPIData(datafetch));
    }
  }, [apiResponse, postApiResponse]);

  const processSave = requestbody => {
    let entityName = '';
    let type = '';
    let resurl = '';
    let relatedStrings = [];
    let requestBody = {};
    let selectedRelatedDataType = [];
    let pageNumber = 0;
    entityName = requestbody.entityType;
    selectedRelatedDataType = requestbody.relatedEntityType.split(',');
    requestBody = requestbody.adaquery;
    type = entityName.toLowerCase();
    selectedRelatedDataType.forEach(relatedType => {
      relatedStrings.push(relatedType);
    });
    resurl = `${type}&` + (relatedStrings.length > 0 ? `relatedtypes=${relatedStrings.toString()}&` : '');
    let apiUrl = `${baseUrl}${resurl}`;
    dispatch(pushRunUrl(apiUrl));
    let paginationStringOrigin = `limit=10&offset=${pageNumber + 1}`;
    let riskUrl = apiUrl + paginationStringOrigin;
    dispatch(getPostResponseAPIData([riskUrl], requestBody, 'run'));
  };

  const RenderBody = () => {
    if (showCard) {
      return /*#__PURE__*/React.createElement(CustomQueryBody, null);
    }
  };

  const getMessage = () => {
    switch (true) {
      case filterCleared:
        return "Please define the filters in your query, click 'Run' to see results";

      case newFilterApplied:
        return "The filters have been modified, please click 'Run' again to see updated results";

      default:
        return "Please click 'Run' to see the results";
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "App custom-query-container"
  }, /*#__PURE__*/React.createElement(CustomQueryHeader, null), !setLoaderComp && !showCard && !showTable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "label-result-text"
  }, "Results: "), /*#__PURE__*/React.createElement("div", {
    style: customQueryStyles.resultBox
  }, getMessage())), showCard && !showTable && /*#__PURE__*/React.createElement(RenderBody, null), setLoaderComp && /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    role: "status",
    style: customQueryStyles.spinnerStyle
  }), !setLoaderComp && relationTableData && !relationTableData.data.length > 0 && !showCard && showTable && /*#__PURE__*/React.createElement("div", {
    style: customQueryStyles.alignCenter
  }, /*#__PURE__*/React.createElement("h3", {
    style: customQueryStyles.noDataHeader
  }, "There are no records for this query."), /*#__PURE__*/React.createElement("p", {
    style: customQueryStyles.noDataBody
  }, "Try different filters and run your query again to see results.")), showTable && relationTableData && relationTableData.data.length > 0 && /*#__PURE__*/React.createElement(ResultTable, null), showSnackLoader && !isSnackOpen ? /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    role: "status",
    style: customQueryStyles.spinnerStatusPopUp
  }) : isSnackOpen && /*#__PURE__*/React.createElement(SnackBar, {
    saveResponseData: saveResponseData,
    open: isSnackOpen,
    message: message,
    status: status
  }));
};

export default CustomQuery;